import { forwardRef, type ButtonHTMLAttributes } from "react";
import { textButtonClasses, type TextButtonVariant } from "./textButtonClasses";

export type { TextButtonVariant };

export interface TextButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: TextButtonVariant;
}

/**
 * TextButton — botão de texto inline sem fundo.
 * Usar para: "Ver todos", "Ler mais", "Trocar foto", "Cancelar".
 *
 * variant="link"   → cor primária, sublinhado ao hover
 * variant="subtle" → cinza, clareia ao hover
 *
 * Para NAVEGAR, use `<Link>` + {@link textButtonClasses} em vez de um `onClick`
 * com `navigate` — o botão perde clique do meio e nova aba.
 */
export const TextButton = forwardRef<HTMLButtonElement, TextButtonProps>(
  function TextButton({ variant = "link", className, children, ...props }, ref) {
    return (
      <button ref={ref} type="button" className={textButtonClasses(variant, className)} {...props}>
        {children}
      </button>
    );
  },
);

TextButton.displayName = "TextButton";
